import {SET_SELECTED_ONSETS} from 'constants/action-types.js';
import {SET_ONSET_THRESHOLD} from 'constants/action-types.js';
import {SET_SHOW_ONSETS} from 'constants/action-types.js';

let initialState = {
    selectedOnsets: {},
    onsetThreshold: 0.5,
    showingOnsets: false,
};

const waveformReducer = (state = initialState, action) => {
    let newState = {... state};
    switch (action.type) {
    case SET_SELECTED_ONSETS:
        newState.selectedOnsets[action.payload.id] =
            action.payload.selectedOnsets;
        return newState;
    case SET_ONSET_THRESHOLD:
        return {
            ... state,
            onsetThreshold: action.payload
        };
    case SET_SHOW_ONSETS:
        return {
            ... state,
            showingOnsets: action.payload
        };
    default:
        return state;
    }
}

export default waveformReducer;
 
